module.exports = __webpack_public_path__ + "img/wisdom5.cbc665a0.png";